import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokPlainTextFaqType } from '../../model/storyblokTypes.generated'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokPlainTextFaq: FC<
  StoryblokComponentProps<StoryblokPlainTextFaqType>
> = ({ blok }) => (
  <section
    itemProp="mainEntity"
    itemScope
    itemType="https://schema.org/Question"
  >
    <div itemProp="name">
      <StoryblokComponentsRenderer bloks={blok.question} />
    </div>
    <div
      itemProp="acceptedAnswer"
      itemScope
      itemType="https://schema.org/Answer"
    >
      <div itemProp="text">
        <StoryblokComponentsRenderer bloks={blok.answer} />
      </div>
    </div>
  </section>
)
